<script lang="ts">
  import { z } from 'zod'
  import Input from '../../input/Input.svelte'
  import { validatedForm } from '../../../hooks/forms'

  const { defaultValue, onRename, onSuccess, name } = $props<{
    defaultValue: string
    name: string
    onRename: (name: string) => Promise<void>
    onSuccess: () => void
  }>()

  const renameSchema = z.object({
    name: z.string(),
  })

  let formElement = $state<HTMLFormElement>()

  const {
    onSubmit: onPrinterRename,
    formValues,
    setValue,
  } = $derived(validatedForm({
    zodSchema: renameSchema,
    submitFunction: values => onRename(values.name),
    onSuccess,
  }))

  $effect(() => {
    setValue('name', defaultValue)
    setTimeout(() => {
      const inputElement = formElement?.elements.namedItem(
        name,
      ) as HTMLInputElement
      if (inputElement) {
        inputElement.focus()
        inputElement.select()
      }
    }, 0)
  })
</script>

<form
  bind:this={formElement}
  onsubmit={onPrinterRename}
>
  <Input
    {name}
    autocomplete="off"
    type="text"
    variant="ghost"
    bind:value={$formValues.name}
  />
</form>

<style lang="scss">
  form {
    width: 100%;
  }
</style>
